import { render, staticRenderFns } from "./OtherDocumentModal.vue?vue&type=template&id=0009dfda"
import script from "./OtherDocumentModal.vue?vue&type=script&lang=js"
export * from "./OtherDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports